/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  MultifamilyTourModal contants
 */

export const CONTACT_PREFERENCE_OPTIONS = {
  ANY: 'Any',
  CALL: 'Call',
  EMAIL: 'Email',
  TEXT: 'Text',
} as const

// ['Any', 'Call', 'Email', 'Text']
export const CONTACT_PREFERENCES = [
  CONTACT_PREFERENCE_OPTIONS.ANY,
  CONTACT_PREFERENCE_OPTIONS.CALL,
  CONTACT_PREFERENCE_OPTIONS.EMAIL,
  CONTACT_PREFERENCE_OPTIONS.TEXT,
] as const
export const CONTACT_PREFERENCES_VALUES = {
  [CONTACT_PREFERENCE_OPTIONS.ANY]: 1,
  [CONTACT_PREFERENCE_OPTIONS.CALL]: 2,
  [CONTACT_PREFERENCE_OPTIONS.EMAIL]: 3,
  [CONTACT_PREFERENCE_OPTIONS.TEXT]: 4,
} as const

export const HAS_ACTIVE_REQUESTS = 'User has active tour requests'
